// Regular expression for phone numbers
export const usPhoneNumberRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
export const phoneNumberPattern = /^(\+1|1)?[.-]?(\d{3})[.-]?(\d{3})[.-]?(\d{4})$/;

export const isValidEmailAddress = (email: string) => {
  // Define a regular expression for an email address
  const emailRegex =
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/; // eslint-disable-line

  // Test if the input matches the email address pattern
  return emailRegex.test(email);
};

/*
 * Format the mobile number based on country
 * @param mobileNumber
 * @returns
 */
export const mobileNumberFormat = (mobileNumber: string) => {
  let template = ('' + mobileNumber).replace(/\D/g, '');
  if (mobileNumber.startsWith('+') && mobileNumber.length > 5) {
    template = template.substring(1); // Remove the first characters
  }
  const expressionMatch = template.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (expressionMatch) {
    mobileNumber = [
      '(',
      expressionMatch[2],
      ') ',
      expressionMatch[3],
      '-',
      expressionMatch[4],
    ].join('');
  } else {
    const regex = /[() -]/g;
    // Use the replace method to remove the matched characters
    mobileNumber = mobileNumber.replace(regex, '');
  }
  return mobileNumber;
};

/**
 * Format a phone number for display as "+1 XXX XXX XXXX" (NANP).
 * Accepts +1XXXXXXXXXX, 1XXXXXXXXXX, or a plain 10-digit number.
 * Other country codes / lengths are returned unchanged.
 */
export const phoneNumberDisplayFormat = (phoneNumber: string): string => {
  const digits = ('' + phoneNumber).replace(/\D/g, '');

  let national = digits;
  if (digits.length === 11 && digits.startsWith('1')) {
    national = digits.slice(1);
  } else if (digits.length !== 10) {
    return phoneNumber;
  }

  return `+1 ${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
};

